import bankaccountdigit from './bankaccountdigit';
import cnpj from './cnpj';
import cpf from './cpf';
import creditcard from './creditcard';
import document from './document';
import expirydate from './expirydate';
import money from './money';
import moneyNoSymbol from './moneyNoSymbol';
import number from './number';
import numberandzero from './numberandzero';
import onlylettersandspace from './onlylettersandspace';
import percent from './percent';
import phone from './phone';
import singledigit from './singledigit';
import zipcode from './zipcode';

import type { IMask } from 'interfaces/IMask';

const masks: IMask[] = [
  { name: 'zipcode', ...zipcode },
  { name: 'phone', ...phone },
  { name: 'document', ...document },
  { name: 'cpf', ...cpf },
  { name: 'cnpj', ...cnpj },
  { name: 'money', ...money },
  { name: 'moneyNoSymbol', ...moneyNoSymbol },
  { name: 'percent', ...percent },
  { name: 'number', ...number },
  { name: 'creditcard', ...creditcard },
  { name: 'expirydate', ...expirydate },
  { name: 'onlylettersandspace', ...onlylettersandspace },
  { name: 'singledigit', ...singledigit },
  { name: 'numberandzero', ...numberandzero },
  { name: 'bankaccountdigit', ...bankaccountdigit },
];
export default masks;
